const STRINGS = {
  MODAL_MODE: {
    ADD: "A",
    EDIT: "E",
    DELETE: "D",
    SUCCESS: "S",
    FAILURE: "F",
    CONTINUE: "C",
    DEFAULT: "",
  },
  MODAL_SIZE: {
    X_SMALL: "xs",
    SMALL: "sm",
    MEDIUM: "md",
    LARGE: "lg",
  },
};
export default STRINGS;
